// extracted by mini-css-extract-plugin
module.exports = {"badge":"sber-badge_badge__PEAa5","text":"sber-badge_text__xUdOM"};